import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  tiendaObtenerOverview,
  tiendaObtenerUltimoPago,
  tiendaAgregarCuponReferido,
  tiendaObtenerAlertaMasiva,
} from '../../store/actions';
import queryString from 'query-string';
import {
  Grid,
  withStyles,
  Typography,
  Card,
  CardContent,
} from '@material-ui/core';
import {
  ButtonUI,
  ToggleUI,
  AlertUI,
  MassiveAlertUI,
  CardModuleUI,
} from '../common';
import { Regex, RegexExtra, Validate } from '../../other';
import { ModalAgregar } from './subcomponents';
import { createAmplitudeEventWithDevice, amplitude_events } from '../amplitude';
import { Onboarding } from './subcomponents/Onboarding';
import { WrapperLayout } from '../../layouts/WrapperLayout';
import styles from './styles';
class Inicio_ extends Component {
  state = {
    baja: false,
    loading_overview: true,
    loading_pago: true,
    loading_alert: true,
    loading_error: false,
    cupon_descuento: false,
    proximo_vencimiento: {
      id: 0,
      monto: 0,
      fecha_vencimiento: null,
      dias_vencimiento: 0,
      fecha_corte: null,
      dias_corte: 0,
      paga: 0,
      cerrada: 0,
      fecha_pago: null,
      periodo_prueba: 0,
    },
    overview: {
      ventas_activas: 0,
      envios_pendientes: 0,
      cobros_pendientes: 0,
      cantidad_clientes: 0,
    },
    agregar: {
      ca_codigo: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Ingresar código',
        id: 'ca_codigo',
        name: 'ca_codigo',
        change_param: 'agregar',
        regex: Regex.CUPON_DESCUENTO,
        value: '',
        default_value: '',
        placeholder: 'Mi código',
        messages: {
          error: 'Ingrese un cupón válido',
          error_extra: RegexExtra.CUPON_DESCUENTO,
        },
      },
    },
    forms: {
      agregar: false,
    },
    modals: {
      agregar: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    if (localStorage.getItem('show-alert')) {
      const showAlert = JSON.parse(localStorage.getItem('show-alert'));
      this.setState({
        alert: {
          ...this.state.alert,
          ...showAlert,
        },
      });

      localStorage.removeItem('show-alert');
    }

    let { nombre, dominio } = queryString.parse(this.props.location.search);
    if (nombre && dominio) {
      this.props.history.push('/');
    }

    this.props.tiendaObtenerOverview((err, resp) => {
      let overview = resp.data.overview;

      let baja = false;
      if (resp.data.tienda) {
        baja = resp.data.tienda.t_offmode === 2 ? true : false;
      }

      this.setState({
        baja: baja,
        loading_overview: false,
        loading_error: this.state.loading_error || err,
        cupon_descuento: resp.data.cupon_descuento,
        overview: overview,
      });
    });

    this.props.tiendaObtenerUltimoPago((err, resp) => {
      let proximo_vencimiento = resp.data;
      this.setState({
        loading_pago: false,
        loading_error: this.state.loading_error || err,
        proximo_vencimiento: proximo_vencimiento,
      });
    });

    if (this.props.alerta.close === false) {
      this.props.tiendaObtenerAlertaMasiva(() => {
        this.setState({
          loading_alert: false,
        });
      });
    } else {
      this.setState({
        loading_alert: false,
      });
    }
  }

  getHomeMessages = () => {
    const tienda = this.props.tienda;
    const red = 'secondary';
    const grey = 'textSecondary';
    const green = 'primary';

    if (this.state.baja) {
      return {
        title: {
          text: `¡Qué bueno que hayas regresado, ${tienda.t_nombre}!`,
          color: green,
        },
        subtitle: {
          text: 'Tu tienda se encuentra dada de baja pero podés reactivarla ahora mismo',
        },
        button: {
          text: 'Reactivar',
          color: green,
          url: '/baja',
        },
      };
    } else {
      const cupon = !!this.state.cupon_descuento;
      const factura = this.state.proximo_vencimiento;

      if (tienda.t_debito_automatico === 0 && tienda.t_pago_manual === 0) {
        if (tienda.t_prueba === 1) {
          if (factura.paga === 0 && factura.periodo_prueba === 1) {
            if (factura.dias_vencimiento >= 1) {
              return {
                title: {
                  text:
                    factura.dias_vencimiento > 1
                      ? `¡Tenés ${factura.dias_vencimiento} días de prueba!`
                      : '¡Tenés 1 día de prueba!',
                  color: factura.dias_vencimiento > 3 ? green : grey,
                },
                subtitle: {
                  text: 'Podés contratar ahora y seguir disfrutando de tu período gratuito.',
                },
                button: {
                  text: 'Contratar ahora',
                  color: factura.dias_vencimiento > 3 ? green : red,
                  url: '/plan',
                },
                coupon: cupon,
              };
            } else if (factura.dias_vencimiento === 0) {
              return {
                title: {
                  text: '¡Hoy finalizan tus días de prueba!',
                  color: grey,
                },
                subtitle: {
                  text: 'Si querés continuar con tu tienda, contrata tu plan.',
                },
                button: {
                  text: 'Contratar ahora',
                  color: red,
                  url: '/plan',
                },
              };
            } else {
              return {
                title: {
                  text: '¡Tus días de prueba han finalizado!',
                  color: grey,
                },
                subtitle: {
                  text: 'Tu tienda dejará de funcionar pronto, si querés continuar con tu tienda, contrata tu plan.',
                },
                button: {
                  text: 'Contratar ahora',
                  color: red,
                  url: '/plan',
                },
              };
            }
          }
        } else {
          if (factura.dias_vencimiento >= 0) {
            //aun no vencio
            return {
              title: {
                text: '¡No tenés ningún plan de suscripción activo!',
                color: grey,
              },
              subtitle: {
                text: `Tu plan vencerá el ${factura.fecha_vencimiento}. Si querés continuar con el servicio luego del vencimiento debes seleccionar uno.`,
              },
              button: {
                text: 'Suscribirme',
                color: red,
                url: '/plan',
              },
            };
          } else {
            //ya vencio, esta en deuda o con dias de gracia
            return {
              title: {
                text: tienda.t_deuda
                  ? `Tu plan venció el ${factura.fecha_vencimiento} y tu tienda ha sido deshabilitada por falta de pago.`
                  : `Tu plan venció el ${factura.fecha_vencimiento}.`,
                color: grey,
              },
              subtitle: {
                text: `Si querés continuar con el servicio debes abonar.`,
              },
              button: {
                text: 'Pagar plan',
                color: red,
                url: '/plan',
              },
            };
          }
        }
      } else if (tienda.t_debito_automatico === 1) {
        if (tienda.t_prueba === 1) {
          return {
            title: {
              text: '¡Gracias por elegirnos!',
              color: green,
            },
            subtitle: {
              text: `El débito automático está activo y el primer débito se realizará el ${factura.fecha_vencimiento}.`,
            },
          };
        }
      } else if (tienda.t_pago_manual === 1) {
        if (factura.paga === 0 && factura.dias_vencimiento <= 10) {
          if (factura.dias_vencimiento >= 0) {
            //el plan aun no vencio
            return {
              title: {
                text: 'Ya puedes abonar tu plan',
                color: factura.dias_vencimiento > 3 ? green : grey,
              },
              subtitle: {
                text:
                  factura.dias_vencimiento === 0
                    ? 'Tu plan vence hoy y se encuentra disponible para ser abonado.'
                    : `Tu plan con vencimiento ${factura.fecha_vencimiento} se encuentra disponible para ser abonado.`,
              },
              button: {
                text: 'Pagar plan',
                color: factura.dias_vencimiento > 3 ? green : red,
                url: '/plan',
              },
            };
          } else {
            //ya vencio, esta en deuda o con dias de gracia
            return {
              title: {
                text: tienda.t_deuda
                  ? `Tu plan venció el ${factura.fecha_vencimiento} y tu tienda ha sido deshabilitada por falta de pago.`
                  : `Tu plan venció el ${factura.fecha_vencimiento}.`,
                color: grey,
              },
              subtitle: {
                text: `Si querés continuar con el servicio debes abonar.`,
              },
              button: {
                text: 'Pagar plan',
                color: red,
                url: '/plan',
              },
            };
          }
        }
      }

      //caso default "hola"
      return {
        title: {
          text: `¡Hola,  ${tienda.t_nombre}!`,
          color: green,
        },
        subtitle: {
          text: 'Este es tu espacio para crear y gestionar tu tienda online. ¡Te damos la bienvenida al panel de control!',
        },
      };
    }
  };

  handleOnboardingError = (err) => {
    this.setState({
      loading_error: this.state.loading_error || err,
    });
  };

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  modalHandler = (open, id, aditional) => {
    this.setState({
      modals: {
        ...this.state.modals,
        [id]: open,
      },
    });
  };

  handleSubmitAgregar = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        agregar: true,
      },
    });

    let form = this.state.agregar;

    if (Validate.validar_formulario(form)) {
      this.props.tiendaAgregarCuponReferido(
        {
          ca_codigo: form.ca_codigo.value,
        },
        (err, resp) => {
          if (err) {
            this.setState({
              forms: {
                ...this.state.forms,
                agregar: false,
              },
              alert: {
                ...this.state.alert,
                open: true,
                message: resp.message,
                type: 'error',
              },
            });
          } else {
            let proximo_vencimiento = resp.data;
            this.setState({
              forms: {
                ...this.state.forms,
                agregar: false,
              },
              alert: {
                ...this.state.alert,
                open: true,
                message: resp.message,
                type: 'success',
              },
              modals: {
                ...this.state.modals,
                agregar: false,
              },
              proximo_vencimiento: proximo_vencimiento,
              cupon_descuento: false,
            });
          }
        }
      );
    } else {
      Validate.validar_formulario_actualizar_obj(form, (new_form) => {
        this.setState({
          forms: {
            ...this.state.forms,
            agregar: false,
          },
          agregar: new_form,
        });
      });
    }
  };

  render() {
    let { classes } = this.props;

    const idCountry = this.props.tienda.Country_idCountry || 'ARG';

    return (
      <WrapperLayout
        loading={
          this.state.loading_overview ||
          this.state.loading_pago ||
          this.state.loading_alert
        }
        error={this.state.loading_error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <ModalAgregar
          agregar={this.state.agregar}
          handleSubmit={this.handleSubmitAgregar}
          handleChange={this.handleChange}
          modalHandler={this.modalHandler}
          modal_state={this.state.modals.agregar}
          form_state={this.state.forms.agregar}
        />
        <Grid
          container
          spacing={24}
          alignItems="center"
          justify="space-between"
        >
          <ToggleUI show={!this.state.baja}>
            <Grid item xs={12}>
              <MassiveAlertUI />
            </Grid>
          </ToggleUI>
          <Grid item xs={12}>
            <CardModuleUI>
              <Grid container className={classes.main_text_container}>
                <Grid item xs={12}>
                  <Typography
                    variant="h1"
                    className={
                      this.getHomeMessages().title?.color === 'primary'
                        ? classes.main_title_green
                        : classes.main_title_grey
                    }
                  >
                    {this.getHomeMessages().title.text}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h3" className={classes.hello_subtitle}>
                    {this.getHomeMessages().subtitle.text}
                  </Typography>
                </Grid>
                <ToggleUI show={!!this.getHomeMessages().button}>
                  <Grid container alignItems="center" spacing={24}>
                    <Grid item>
                      <ButtonUI
                        type={'link'}
                        textTransformNone={true}
                        link={`${this.getHomeMessages().button?.url}`}
                        fixedMinWidth={true}
                        label={`${this.getHomeMessages().button?.text}`}
                        color={this.getHomeMessages().button?.color}
                      />
                    </Grid>
                    <ToggleUI
                      show={
                        !!this.state.cupon_descuento &&
                        this.state.proximo_vencimiento.dias_vencimiento > 1 &&
                        idCountry !== 'COL'
                      }
                    >
                      <Grid item>
                        <Typography className={classes.coupon_text}>
                          ¿Tenés un cupón?{' '}
                          <a
                            href="#!"
                            className={classes.coupon_link}
                            onClick={() => this.modalHandler(true, 'agregar')}
                          >
                            Ingresar
                          </a>
                        </Typography>
                      </Grid>
                    </ToggleUI>
                  </Grid>
                </ToggleUI>
              </Grid>
            </CardModuleUI>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={24}
          classes={{ container: classes.stat_container }}
        >
          <Grid item xs={12}>
            <Onboarding handleOnboardingError={this.handleOnboardingError} />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={24}
          classes={{ container: classes.stat_container }}
        >
          <Grid item xs={12}>
            <CardModuleUI>
              <p className={classes.metric_title}>Métricas</p>
              <Grid container>
                <Grid item md={3} sm={6} xs={6}>
                  <Card
                    className={classes.card}
                    onClick={(e) => {
                      createAmplitudeEventWithDevice(
                        amplitude_events.ventas_activas.event_name
                      );
                      this.props.history.push(`/ventas`);
                    }}
                  >
                    <CardContent
                      classes={{
                        root: classes.card_content,
                      }}
                    >
                      <Typography className={classes.stat_title}>
                        VENTAS ACTIVAS
                      </Typography>
                      <Typography className={classes.stat_subtitle}>
                        {this.state.overview.ventas_activas}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={3} sm={6} xs={6}>
                  <Card
                    className={classes.card}
                    onClick={(e) => {
                      createAmplitudeEventWithDevice(
                        amplitude_events.envios_pendientes.event_name
                      );
                      this.props.history.push(`/ventas`);
                    }}
                  >
                    <CardContent
                      classes={{
                        root: classes.card_content,
                      }}
                    >
                      <Typography className={classes.stat_title}>
                        ENVÍOS PENDIENTES
                      </Typography>
                      <Typography className={classes.stat_subtitle}>
                        {this.state.overview.envios_pendientes}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={3} sm={6} xs={6}>
                  <Card
                    className={classes.card}
                    onClick={(e) => {
                      createAmplitudeEventWithDevice(
                        amplitude_events.cobros_pendientes.event_name
                      );
                      this.props.history.push(`/ventas`);
                    }}
                  >
                    <CardContent
                      classes={{
                        root: classes.card_content,
                      }}
                    >
                      <Typography className={classes.stat_title}>
                        COBROS PENDIENTES
                      </Typography>
                      <Typography className={classes.stat_subtitle}>
                        {this.state.overview.cobros_pendientes}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={3} sm={6} xs={6}>
                  <Card
                    className={classes.card}
                    onClick={(e) => {
                      createAmplitudeEventWithDevice(
                        amplitude_events.clientes.event_name
                      );
                      idCountry === 'COL'
                        ? this.props.history.push(`/`)
                        : this.props.history.push(`/clientes`);
                    }}
                  >
                    <CardContent
                      classes={{
                        root: classes.card_content,
                      }}
                    >
                      <Typography className={classes.stat_title}>
                        CLIENTES
                      </Typography>
                      <Typography className={classes.stat_subtitle}>
                        {this.state.overview.cantidad_clientes}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </CardModuleUI>
          </Grid>
        </Grid>
      </WrapperLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tienda: state.tienda,
    alerta: state.alerta,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    tiendaObtenerOverview: (callback) =>
      dispatch(tiendaObtenerOverview(callback)),
    tiendaObtenerUltimoPago: (callback) =>
      dispatch(tiendaObtenerUltimoPago(callback)),
    tiendaAgregarCuponReferido: (data, callback) =>
      dispatch(tiendaAgregarCuponReferido(data, callback)),
    tiendaObtenerAlertaMasiva: (callback) =>
      dispatch(tiendaObtenerAlertaMasiva(callback)),
  };
};

export const Inicio = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Inicio_)
);
